module.exports = __webpack_public_path__ + "media/src/assets/fonts/mplus-1p-bold-f85e57e5026b3f7ef4674f2e5cab0b1a.ttf";